import { EmbeddedRouteName } from '@/shared/enums';

export default ({ slug, id, type, articleId, articleSlug, articleType, component: { $route, $router } }) => {
  const query = $route.query;

  if (articleId) {
    const { slug, id, type } = $route.params;

    return $router.replace({
      name: EmbeddedRouteName.PLAYER_WITH_ARTICLE,
      params: {
        slug,
        type,
        id,
        articleSlug,
        articleType: articleType.toLowerCase(),
        articleId,
        isFollowingElement: true,
      },
      query,
    });
  }

  $router.replace({
    name: EmbeddedRouteName.PLAYER,
    params: {
      slug,
      type: type.toLowerCase(),
      id,
    },
    query,
  });
};
